import React from 'react';
import { Text, useTheme } from '@chakra-ui/react';

import { Image } from '@ldfeplatform/componentlibrary.ui.atoms.image';

import styles from './card-information.module.scss';
import { ICardInfoProps } from './card-information.interface';

const CardInformation: React.FC<ICardInfoProps> = ({ image, imageAlt, title, subtitle, reverse = false }) => {
  const { common } = useTheme();
  return (
    <div className={`${styles.cardInfo} ${reverse && styles.reverse}`} data-testid="card-information">
      {image && (
        <div className={styles.imageSection}>
          <Image alt={imageAlt} src={image} width={48} height={48} />
        </div>
      )}

      <div className={styles.textSection}>
        <Text sx={{ fontWeight: 'bold' }} {...common?.common02Regular} className={styles.title}>
          {title}
        </Text>
        <Text {...common?.common02Regular} className={styles.subtitle}>
          {subtitle}
        </Text>
      </div>
    </div>
  );
};

export default CardInformation;
